import { Component, OnInit, ViewChild } from '@angular/core';
import { TradingSystemGraficoWeeklyComponent } from '../../shared/trading-system-grafico-weekly/trading-system-grafico-weekly.component';
import { CrosstrendService } from 'src/app/services/crosstrend.service';
import * as Highcharts from 'highcharts';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { CommonModule } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';

@Component({
  selector: 'app-crosstrend2-backtest-h4',
  standalone: true,
  templateUrl: './crosstrend2-backtest-h4.component.html',
  styleUrls: ['./crosstrend2-backtest-h4.component.scss'],
  imports: [
    TradingSystemGraficoWeeklyComponent, CommonModule, 
    HighchartsChartModule, TradingSystemSummaryComponent
  ]
})
export class Crosstrend2BacktestH4Component implements OnInit {

  datiSummary: any[] = []
  datiTrading: any[] = []
  tsSummary: TradingSystemSummary = new TradingSystemSummary()
  mercatoSelezionato: any = {}

  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false
  @ViewChild('chartWeek') chartWeek!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartBuy') chartWeekBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartSell') chartWeekSell!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonth') chartMonth!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlyBuy') chartMonthlyBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlySell') chartMonthSell!: TradingSystemGraficoWeeklyComponent
  timeFrame: string = 'h4'
  constructor(private serv: CrosstrendService) { }

  ngOnInit(): void {
    this.serv.crosstend2Summary(this.timeFrame).subscribe((data: any) => {
      if (data.res == 'ok') {
        this.datiSummary = data.data
      }
    })
  }

  caricaMercato(mkt: any) {
    this.mercatoSelezionato = mkt
    this.serv.operazioniCrossTrend(mkt.market,this.timeFrame).subscribe((data: any) => {
      let prog = 0
      if (data.res == 'ok'){
        this.datiTrading = data.data.map((el: any) => {
          el.punti = parseFloat(el.profit)
          el.ora = el.oraclose
          el.profit = parseFloat(el.profit)
          prog += el.punti
          el.prog = prog
          return el
        })
        this.chartWeek.caricaDati(this.datiTrading)
        this.chartWeekBuy.caricaDati(this.datiTrading.filter((el:any)=> el.verso=='buy'))
        this.chartWeekSell.caricaDati(this.datiTrading.filter((el:any)=> el.verso=='sell'))
        this.chartMonth.caricaDatiMese(this.datiTrading)
        this.chartMonthlyBuy.caricaDatiMese(this.datiTrading.filter((el:any)=> el.verso=='buy'))
        this.chartMonthSell.caricaDatiMese(this.datiTrading.filter((el:any)=> el.verso=='sell'))
        this.tsSummary.spread = mkt.spread
        this.tsSummary.popolaDati(mkt.market,mkt.pip,this.datiTrading)
        this.aggiornaGrafico(this.datiTrading)
      }
    })
  }

  aggiornaGrafico(data: any) {
    let s1 = data.map((el: any) =>  [el.oraclose,el.prog])
    let s2 = data.map((el: any) =>  [el.oraclose, parseFloat(el.vclose)])
    this.chartOptions = {
      title: {
        text: 'Crosstrend2 Backtest H4 ' + this.mercatoSelezionato.market
      },
      chart: {
        zooming: {
          type: 'x'
        },
        events: {
          redraw: function() {
            console.log('The chart was just redrawn')
            console.log(this.xAxis);
        console.log(this.yAxis);
          }
        }
      },
      series: [{
        name: 'Progressivo',
        data: s1,
        type: 'line',
        color: 'lime',
      }, {
        name: this.mercatoSelezionato.market,
        data: s2,
        type: 'line',
        dashStyle: 'ShortDot',
        yAxis: 1,
      }],
      yAxis: [
        {
          title: {
            text: 'Progressivo'
          }
        },
        {
          title: {
            text: 'Cambio'
          },
          opposite: true
        }
      ],
    }
    this.updateFlag = true
  }

}
